export const configE2E = {
  baseUrl: "https://test-internal.vodafone.dev.billing.affinity.io/dev-v1",
};
